/* eslint-disable react-hooks/exhaustive-deps */
// TOPO "Larissa" (modelo_topo = 14): barra do modelo "Larissa" (linguagem visual de um site de
// referência — monocromático, serifa Lora + Inter — com as cores do tenant via larissa.ts).
//  - BARRA SÓLIDA na cor escura do tenant, fixa, 80px (72 no celular): logo à esquerda (em placa
//    clara — o cadastro não tem versão clara da logo), menu do tenant em Inter 14px no centro (só
//    ≥ 1280px e dentro de um ORÇAMENTO DE CARACTERES: rótulo que não cabe vai para o painel), CTA de
//    texto "Anuncie seu imóvel" e HAMBÚRGUER sempre visível à direita;
//  - some ao rolar para baixo (> 160px) e volta ao subir; um espaçador reserva a altura;
//  - o hambúrguer abre um PAINEL de 260px ancorado sob a barra (desktop) com o menu inteiro em
//    serifa, favoritos, "Buscar imóveis", contatos e redes em círculos; no celular o painel é uma
//    GAVETA lateral com véu (Esc fecha, foco preso, scroll travado, troca de rota fecha).
// Dados: mesmos helpers do Horizonte/Atelier (menuDoTenant, contatosDoTenant, redesDoTenant,
// favoritosHref). prefers-reduced-motion: a barra não desliza nem some.
// Default export = ErrorBoundary com fallback pro Topo padrão (molde dos topos 10–12).
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useId, useRef, useState } from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaMapMarkerAlt, FaPhoneAlt, FaTiktok, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { anuncieWhatsAppDoSite } from '../../../utils/anuncieWhatsApp';
import { favoritosHref, MaskPhone, removerAcentos } from '../../../utils/FunctionsGlobals';
import { trackMetaEvent } from '../../../utils/metaPixel';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import { appendCodsiteQuery } from '../../../utils/url';
import { useAuth, useRegiao, useSiteRegiao } from '../../context/Info';
import { temSeletorIdiomas } from '../../../utils/idiomaMoedaSite';
import { IdiomaNavItem } from '../idiomas/menu';
import Topo from '../topo/Topo';
import { contatosDoTenant, linkWhatsAppDoTenant, menuDoTenant, mesmaRota, nomeDaEmpresa, redesDoTenant, paletaLarissa, useLogoSemPlaca, useMovimentoReduzido, varsLarissa } from '../larissa/larissa';
import type { ItemMenu } from '../larissa/larissa';
import '../larissa/LarissaFonte.module.css';
import styles from './TopoLarissa.module.css';

interface ITopoLarissa {
    site: any;
    setActiveDrawer: any;
    setBuscaAvancada?: any;
    fallback?: React.ReactNode;
}

const ROLAGEM_PARA_ESCONDER = 160;
const ITENS_NA_BARRA = 6;
/** Orçamento da barra em "caracteres" (Inter 14px ≈ 7,6px por caractere; cada item custa +4 pelo vão de
 *  32px): o que passar fica só no painel. Sem isso, rótulos longos estouram a zona do menu e empurram a
 *  logo/CTA (lição do modelo #10). Depende só dos dados → SSR-estável. */
const ORCAMENTO_CARACTERES = 76;
const itensQueCabem = (itens: ItemMenu[]): ItemMenu[] => {
    const cabem: ItemMenu[] = [];
    let soma = 0;
    for (const item of itens.slice(0, ITENS_NA_BARRA)) {
        soma += String(item.label || '').length + 4;
        if (soma > ORCAMENTO_CARACTERES && cabem.length >= 2) break;
        cabem.push(item);
    }
    return cabem;
};
const ANUNCIE_RE = /anunci|cadastre seu imovel|venda seu imovel/;
const FOCAVEIS = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

const ICONE_REDE: Record<string, React.ComponentType<{ 'aria-hidden'?: boolean }>> = {
    Instagram: FaInstagram,
    Facebook: FaFacebook,
    Youtube: FaYoutube,
    Tiktok: FaTiktok,
    Linkedin: FaLinkedin,
};

const TopoLarissaInner: React.FC<ITopoLarissa> = ({ site: siteProp, setActiveDrawer }) => {
    // MULTI-REGIÃO: contatos (tel1/tel2) trocados pelos da região ativa quando houver.
    const site = useSiteRegiao(siteProp);
    const { allDataHome, favorito } = useAuth();
    const router = useRouter();
    const codsite = Array.isArray(router.query?.codsite) ? router.query?.codsite[0] : router.query?.codsite;
    const reduzido = useMovimentoReduzido();
    // MULTI-FILIAIS (modo popup/tela): a filial ativa vira um botão na barra que abre o seletor
    // do site. Tenant sem regiões (ou no modo barra) ⇒ nomeFilial vazio ⇒ nada muda no markup.
    const { regiaoAtiva, regiaoMatriz, modoPopup, setFilialPopupAberto } = useRegiao();
    const nomeFilial = modoPopup ? regiaoAtiva?.nome || regiaoMatriz?.nome || '' : '';
    const uid = useId().replace(/:/g, '');
    const idPainel = `lr-painel-${uid}`;

    const [isMounted, setIsMounted] = useState(false);
    const [oculto, setOculto] = useState(false);
    const [aberto, setAberto] = useState(false);
    const botaoRef = useRef<HTMLButtonElement | null>(null);
    const painelRef = useRef<HTMLDivElement | null>(null);
    const primeiroLinkRef = useRef<HTMLAnchorElement | null>(null);

    // ---- rolagem: some descendo (> 160px), volta subindo ----
    useEffect(() => {
        setIsMounted(true);
        let raf = 0;
        let anterior = window.scrollY || 0;
        const ler = () => {
            raf = 0;
            const y = window.scrollY || 0;
            if (y < ROLAGEM_PARA_ESCONDER || y < anterior - 2) setOculto(false);
            else if (y > anterior + 2) setOculto(true);
            anterior = y;
        };
        const aoRolar = () => {
            if (!raf) raf = window.requestAnimationFrame(ler);
        };
        window.addEventListener('scroll', aoRolar, { passive: true });
        return () => {
            window.removeEventListener('scroll', aoRolar);
            if (raf) window.cancelAnimationFrame(raf);
        };
    }, []);

    // ---- painel: Esc fecha, foco entra, circula (Tab) e volta ao botão; na gaveta (celular) trava a rolagem ----
    useEffect(() => {
        if (!aberto) return;
        const html = document.documentElement;
        const antes = html.style.overflow;
        const gaveta = window.matchMedia('(max-width: 1023px)').matches;
        if (gaveta) html.style.overflow = 'hidden';
        const teclado = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                setAberto(false);
                return;
            }
            if (e.key !== 'Tab') return;
            const dentro = Array.from(painelRef.current?.querySelectorAll<HTMLElement>(FOCAVEIS) || []).filter((el) => el.offsetParent !== null);
            if (!dentro.length) return;
            const primeiro = dentro[0];
            const ultimo = dentro[dentro.length - 1];
            const ativo = document.activeElement as HTMLElement | null;
            if (e.shiftKey && (ativo === primeiro || !dentro.includes(ativo as HTMLElement))) {
                e.preventDefault();
                ultimo.focus();
            } else if (!e.shiftKey && ativo === ultimo) {
                e.preventDefault();
                primeiro.focus();
            }
        };
        document.addEventListener('keydown', teclado);
        const t = window.setTimeout(() => primeiroLinkRef.current?.focus(), 120);
        const botao = botaoRef.current;
        return () => {
            if (gaveta) html.style.overflow = antes;
            document.removeEventListener('keydown', teclado);
            window.clearTimeout(t);
            botao?.focus();
        };
    }, [aberto]);
    useEffect(() => {
        const fechar = () => setAberto(false);
        router.events?.on('routeChangeStart', fechar);
        return () => router.events?.off('routeChangeStart', fechar);
    }, [router.events]);

    const withCodsite = (path: string) => (isMounted ? appendCodsiteQuery(path, codsite) : path);

    // ---- dados do tenant (mesma origem dos topos 11/12) ----
    const navItems: ItemMenu[] = menuDoTenant(site, allDataHome);
    const ehAnuncie = (item: ItemMenu) => ANUNCIE_RE.test(removerAcentos(String(item.label || '')).toLowerCase());
    const itemAnuncie = navItems.find(ehAnuncie);
    // o item "Anuncie" do tenant vira o CTA da direita — não repete no menu do centro
    const itensBarra = itensQueCabem(navItems.filter((i) => i !== itemAnuncie));
    const asPath = router.asPath || '/';
    const { phones, ctaPhone, ctaIsWhats, ctaHref } = contatosDoTenant(site, 4);
    const ctaNumero = MaskPhone(ctaPhone?.tel || '');
    const redes = redesDoTenant(site);
    const email = site?.Dados?.email1 || site?.Dados?.email2;
    const empresa = nomeDaEmpresa(site);
    const logoSrc = site?.url_logo ? `${site?.url_logo}?v=${site?.contador_marca || 0}` : '';
    // logo clara (feita p/ fundo escuro) vai direto sobre a base, sem a placa branca — decidido depois de montar
    const semPlaca = useLogoSemPlaca(logoSrc, paletaLarissa(site).base);
    const totalFavoritos = isMounted && Array.isArray(favorito) ? favorito.length : 0;
    const hrefFavoritos = isMounted ? favoritosHref(favorito || [], codsite) : '/imoveis';

    // CTA "Anuncie seu imóvel": o menu do tenant com esse nome; senão o WhatsApp (o próprio do "Anuncie",
    // quando o site tem um — utils/anuncieWhatsApp); sem WhatsApp vira "Fale conosco" (ligação); sem telefone, some.
    const whatsAnuncie = anuncieWhatsAppDoSite(site);
    const cta: { label: string; href: string; externo: boolean; metodo: string } | null = itemAnuncie
        ? { label: 'Anuncie seu imóvel', href: itemAnuncie.href, externo: Boolean(itemAnuncie.external), metodo: 'menu' }
        : whatsAnuncie
        ? { label: 'Anuncie seu imóvel', href: `https://api.whatsapp.com/send?phone=${whatsAnuncie}&text=${encodeURIComponent('Olá, gostaria de anunciar um imóvel.')}`, externo: true, metodo: 'whatsapp' }
        : ctaPhone && ctaIsWhats
        ? { label: 'Anuncie seu imóvel', href: `https://api.whatsapp.com/send?phone=55${String(ctaPhone.tel || '').replace(/\D/g, '')}&text=${encodeURIComponent('Olá, gostaria de anunciar um imóvel.')}`, externo: true, metodo: 'whatsapp' }
        : ctaPhone
        ? { label: 'Fale conosco', href: ctaHref, externo: false, metodo: 'phone' }
        : null;
    const rastrearCta = () => {
        if (!cta) return;
        // WhatsApp/telefone → whatsapp_click (GTM/GA), como no clássico; link de menu ("Anuncie" do tenant) não.
        if (cta.metodo === 'whatsapp' || cta.metodo === 'phone') trackLead(site, null);
        trackMetaEvent(site, 'Contact', { content_name: cta.label, contact_method: cta.metodo, content_category: 'header' });
    };

    const abrirBusca = () => {
        trackMetaEvent(site, 'ViewContent', { content_name: 'Buscar imóveis', content_category: 'header_navigation' });
        setAberto(false);
        setActiveDrawer?.(true);
    };

    const renderItem = (item: ItemMenu, idx: number, cls: string, clsAtivo: string, ref?: React.Ref<HTMLAnchorElement>) => {
        const ativo = !item.external && mesmaRota(asPath, item.href);
        return item.external ? (
            <a key={idx} ref={ref} href={item.href} rel="noopener noreferrer" className={cls} onClick={() => setAberto(false)}>
                {item.label}
            </a>
        ) : (
            <Link key={idx} ref={ref} prefetch={false} href={withCodsite(item.href)} className={`${cls} ${ativo ? clsAtivo : ''}`} aria-current={ativo ? 'page' : undefined} onClick={() => setAberto(false)}>
                {item.label}
            </Link>
        );
    };

    const renderCta = (cls: string) =>
        !cta ? null : cta.externo || cta.metodo === 'phone' ? (
            <a className={cls} href={cta.href} target={cta.externo ? '_blank' : undefined} rel="noopener noreferrer" onClick={rastrearCta}>
                {cta.label}
            </a>
        ) : (
            <Link prefetch={false} className={cls} href={withCodsite(cta.href)} onClick={rastrearCta}>
                {cta.label}
            </Link>
        );

    return (
        // BUILDER: âncora estável do bloco "topo" (cobre esta variante em qualquer página).
        <div className={`${styles.wrapper} ${reduzido ? styles.semMovimento : ''}`} data-builder-section="topo" style={varsLarissa(site)}>
            {/* espaçador: a barra é fixa e sólida — reserva a altura dela */}
            <div className={styles.spacer} aria-hidden="true" />

            <header className={`${styles.header} ${oculto && !aberto && !reduzido ? styles.oculto : ''}`}>
                <div className={styles.barra}>
                    <Link
                        prefetch={false}
                        href={withCodsite('/')}
                        onClick={() => trackMetaEvent(site, 'ViewContent', { content_name: 'Logo da imobiliária', content_category: 'header_navigation' })}
                        className={styles.logoLink}
                        title={`Imobiliária ${empresa}`}
                    >
                        {logoSrc ? (
                            <span className={`${styles.placa} ${semPlaca ? styles.placaSemFundo : ''}`}>
                                <Image src={logoSrc} alt={`Imobiliária ${empresa}`} title={`Imobiliária ${empresa}`} className={styles.logo} height={48} width={200} priority fetchPriority="high" unoptimized />
                            </span>
                        ) : (
                            <span className={styles.logoTexto}>{empresa}</span>
                        )}
                    </Link>

                    <nav className={styles.menu} aria-label="Menu principal">
                        {itensBarra.map((item, idx) => renderItem(item, idx, styles.item, styles.itemAtivo))}
                    </nav>

                    <div className={styles.acoes}>
                        {nomeFilial ? (
                            <button
                                type="button"
                                className={styles.filial}
                                aria-haspopup="dialog"
                                title="Trocar de filial"
                                aria-label={`Filial ${nomeFilial} — trocar de filial`}
                                onClick={() => setFilialPopupAberto(true)}
                            >
                                <FaMapMarkerAlt className={styles.filialPino} aria-hidden="true" />
                                <span className={styles.filialRotulo}>Filial</span>
                                <span className={styles.filialNome}>{nomeFilial}</span>
                                <svg className={styles.filialChevron} viewBox="0 0 12 12" width="10" height="10" aria-hidden="true" focusable="false">
                                    <path d="M2.5 4.5 6 8l3.5-3.5" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                        ) : null}
                        {/* 22/10 (rodada 2): idioma NA BARRA, no contorno das ações do modelo (o da filial), ao lado do
                            ☰ — no celular (≤ 767px, onde o contorno da filial some) só a bandeira num contorno igual; a
                            linha do painel saiu — só com a opção do CRM */}
                        {temSeletorIdiomas(site) ? (
                            <>
                                <IdiomaNavItem ocultarAte={767} classeBotao={styles.filial} estilo={{ '--idm-painel-raio': '8px' } as React.CSSProperties} />
                                <IdiomaNavItem ocultarAcima={767} compacto pilula estilo={{ '--idm-raio': '8px', '--idm-painel-raio': '8px', '--idm-borda-botao': 'rgba(255, 255, 255, 0.28)' } as React.CSSProperties} />
                            </>
                        ) : null}
                        {/* número do WhatsApp no topo (Daniel 15/10: "sem número de WhatsApp no topo"), como no Horizonte;
                            sem WhatsApp, o telefone (ligação). No celular fica só o ícone. */}
                        {ctaPhone ? (
                            <a
                                className={styles.contato}
                                href={ctaHref}
                                rel="noopener noreferrer"
                                target={ctaIsWhats ? '_blank' : undefined}
                                title={ctaPhone.nome || (ctaIsWhats ? `WhatsApp ${ctaNumero}` : `Telefone ${ctaNumero}`)}
                                aria-label={ctaIsWhats ? `Fale conosco pelo WhatsApp ${ctaNumero}` : `Ligar para ${ctaNumero}`}
                                onClick={() => {
                                    trackLead(site, null); // whatsapp_click no GTM/GA, como no Topo clássico (sem imóvel = sem Meta)
                                    trackMetaEvent(site, 'Contact', {
                                        content_name: 'Contato do cabeçalho',
                                        contact_method: ctaIsWhats ? 'whatsapp' : 'phone',
                                        content_category: 'header',
                                    });
                                }}
                            >
                                {ctaIsWhats ? <FaWhatsapp className={styles.contatoIcone} aria-hidden="true" /> : <FaPhoneAlt className={styles.contatoIcone} aria-hidden="true" />}
                                <span className={styles.contatoNumero}>{ctaNumero || 'Fale conosco'}</span>
                            </a>
                        ) : null}
                        {renderCta(styles.cta)}
                        <button ref={botaoRef} type="button" className={styles.botaoMenu} aria-label={aberto ? 'Fechar menu' : 'Abrir menu'} aria-expanded={aberto} aria-controls={idPainel} onClick={() => setAberto((v) => !v)}>
                            <span className={`${styles.hamburguer} ${aberto ? styles.hamburguerAberto : ''}`} aria-hidden="true">
                                <span className={styles.traco} />
                                <span className={styles.traco} />
                                <span className={styles.traco} />
                            </span>
                        </button>
                    </div>
                </div>
            </header>

            {aberto ? (
                <>
                    <div className={styles.veu} onClick={() => setAberto(false)} aria-hidden="true" />
                    <div id={idPainel} ref={painelRef} className={styles.painel} role="dialog" aria-modal="true" aria-label="Menu">
                        <div className={styles.painelTopo}>
                            <span className={styles.rotulo}>Menu</span>
                            <button type="button" className={styles.fechar} onClick={() => setAberto(false)} aria-label="Fechar menu">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                </svg>
                            </button>
                        </div>
                        <nav className={styles.painelNav} aria-label="Menu completo">
                            {navItems.map((item, idx) => renderItem(item, idx, styles.painelLink, styles.painelLinkAtivo, idx === 0 ? primeiroLinkRef : undefined))}
                            <Link prefetch={false} href={hrefFavoritos} className={styles.painelLink} onClick={() => setAberto(false)}>
                                Favoritos{totalFavoritos > 0 ? ` (${totalFavoritos})` : ''}
                            </Link>
                            <button type="button" className={styles.painelLink} onClick={abrirBusca}>
                                Buscar imóveis
                            </button>
                        </nav>

                        {cta && !itemAnuncie ? <div className={styles.painelCta}>{renderCta(styles.painelBotao)}</div> : null}

                        {phones.length > 0 || email ? (
                            <div className={styles.painelBloco}>
                                <span className={styles.rotulo}>Contato</span>
                                <ul className={styles.painelLista}>
                                    {phones.map((p, idx) => (
                                        <li key={idx}>
                                            <a
                                                className={styles.painelContato}
                                                href={p.whats ? linkWhatsAppDoTenant(site, p.tel) : `tel:+55${(p.tel || '').replace(/\D/g, '')}`}
                                                target={p.whats ? '_blank' : undefined}
                                                rel="noopener noreferrer"
                                                onClick={() => {
                                                    trackLead(site, null); // whatsapp_click (GTM/GA), como no menu do Topo clássico
                                                    trackMetaEvent(site, 'Contact', { content_name: 'Contato do menu', contact_method: p.whats ? 'whatsapp' : 'phone', content_category: 'header' });
                                                }}
                                            >
                                                {p.whats ? <FaWhatsapp aria-hidden="true" /> : <FaPhoneAlt aria-hidden="true" />}
                                                <span>
                                                    {MaskPhone(p.tel || '')}
                                                    {p.nome ? ` — ${p.nome}` : ''}
                                                </span>
                                            </a>
                                        </li>
                                    ))}
                                    {email ? (
                                        <li>
                                            <a className={styles.painelContato} href={`mailto:${email}`}>
                                                <span>{email}</span>
                                            </a>
                                        </li>
                                    ) : null}
                                </ul>
                            </div>
                        ) : null}

                        {redes.length > 0 ? (
                            <div className={styles.redes}>
                                {redes.map((r) => {
                                    const Icone = ICONE_REDE[r.rede];
                                    return (
                                        <a key={r.rede} href={r.href} target="_blank" rel="noopener noreferrer" className={styles.rede} aria-label={r.rede} title={r.rede}>
                                            {Icone ? <Icone aria-hidden={true} /> : r.rede}
                                        </a>
                                    );
                                })}
                            </div>
                        ) : null}
                    </div>
                </>
            ) : null}
        </div>
    );
};

// ErrorBoundary → fallback pro Topo padrão (mesmo padrão dos topos 10/11/12).
class TopoLarissa extends React.Component<ITopoLarissa, { hasError: boolean }> {
    constructor(props: ITopoLarissa) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch() {
        // silencioso: o topo degrada pro padrão sem quebrar a página.
    }
    render() {
        const { site, setActiveDrawer, fallback } = this.props;
        const defaultTopo = fallback ?? <Topo site={site} setActiveDrawer={setActiveDrawer} />;
        if (this.state.hasError || !site) return defaultTopo;
        return <TopoLarissaInner {...this.props} />;
    }
}

export default TopoLarissa;
